import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import moment from 'moment';
import { Company, Party, PendingInvoices } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { RootState } from 'store/store';

export const MakePayment = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [party, setParty] = useState<Party>();
    const [amount, setAmount] = useState<number>(0);
    const [balance, setBalance] = useState<number>(0);
    const [pendingInvoices, setPendingInvoices] = useState<PendingInvoices[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [company, setCompany] = useState<Company>();
    const paymentAmountRef = useRef<null | HTMLInputElement>(null)

    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
        }
    }, [user]);

    useEffect(() => {
        if (!party) {
            return;
        }
        ArthaGateway
            .getBalance(party.accountId)
            .then((data) => {
                let totalBalance = data.reduce((sum, d) => sum + d.balance, 0);
                setBalance(totalBalance);
                fetchCompanyDetails();
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });

        ArthaGateway
            .getPendingInvoices(party.partyId)
            .then((data) => {
                data.map((d) => d.isSelected = false);
                setPendingInvoices(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }, [party]);

    const fetchCompanyDetails = () => {
        const cachedCompany = sessionStorage.getItem("company");
        if (cachedCompany) {
            setCompany(JSON.parse(cachedCompany));
        }
        else {
            ArthaGateway
                .getCompany(1)
                .then((data) => {
                    setCompany(data);
                    sessionStorage.setItem("company", JSON.stringify(data));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const selectAllInvoices = () => {
        pendingInvoices.map((invoice) => {
            invoice.isSelected = true;
        });
        setAmount(pendingInvoices.reduce((sum, d) => sum + d.pendingAmount, 0));
        if (paymentAmountRef != null && paymentAmountRef.current != null) {
            paymentAmountRef.current.scrollIntoView();
        }
    }

    const selectInvoice = (invoice: PendingInvoices) => {
        invoice.isSelected = true;
        setAmount(amount + invoice.pendingAmount);
        if (paymentAmountRef != null && paymentAmountRef.current != null) {
            paymentAmountRef.current.scrollIntoView();
        }
    }

    const deselectInvoice = (invoice: PendingInvoices) => {
        invoice.isSelected = false;
        setAmount(amount - invoice.pendingAmount);
        if (paymentAmountRef != null && paymentAmountRef.current != null) {
            paymentAmountRef.current.scrollIntoView();
            paymentAmountRef.current.focus();
        }
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <div className="page page-make-payment">
                    <div className='card bg-primary'>
                        <div className='card-header text-white'>
                            <h2>Pay</h2>
                            <div style={{ marginTop: "20px" }}>
                                <input type="number"
                                    className="form-control"
                                    value={amount}
                                    placeholder="Enter amount"
                                    onChange={(e) => setAmount(parseInt(e.target.value))}
                                    style={{ fontWeight: "bold", fontSize: "2rem", textAlign: "center" }}
                                    ref={paymentAmountRef} />
                            </div>
                            {amount > 0 &&
                                <div className="btn-group d-flex w-100" role="group" style={{ marginTop: "20px" }}>
                                    <a href={`upi://pay?pa=${company?.bankAccount?.upiId}&pn=${company?.name}&am=${amount}&cu=INR`} className="btn btn-dark w-100">
                                        <FontAwesomeIcon icon={faCreditCard} style={{ width: "auto" }} />
                                        &nbsp; Make Payment
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                    <ul className="page-items list-group">
                        {pendingInvoices && pendingInvoices.length > 0 &&
                            <li className="list-group-item card-item">
                                {(party && party?.totalBalance > 0) &&
                                    <div className="btn btn-sm btn-secondary" style={{ float: "right" }} onClick={() => selectAllInvoices()}>
                                        Select All
                                    </div>
                                }
                                <div>
                                    Total Balance
                                </div>
                                <div>
                                    <b>{currencyFormat(balance)}</b>
                                </div>
                            </li>
                        }
                        {pendingInvoices && pendingInvoices.map((pendingInvoice) => (
                            (pendingInvoice?.pendingAmount !== undefined && pendingInvoice?.pendingAmount > 0) &&
                            <li className="list-group-item card-item">
                                {(pendingInvoice.pendingAmount > 0) && !pendingInvoice.isSelected &&
                                    <div className="btn btn-sm btn-secondary" style={{ float: "right" }} onClick={() => selectInvoice(pendingInvoice)}>
                                        Select
                                    </div>
                                }
                                {(pendingInvoice.pendingAmount > 0) && pendingInvoice.isSelected &&
                                    <div className="btn btn-sm btn-success" style={{ float: "right" }} onClick={() => deselectInvoice(pendingInvoice)}>
                                        <FontAwesomeIcon icon={faCircleCheck} style={{ width: "auto" }} />
                                        &nbsp; Selected
                                    </div>
                                }
                                <div>
                                    {pendingInvoice.voucherNumber}
                                </div>
                                <div className='date'>{moment(pendingInvoice.voucherDate).format("DD MMM YYYY")}</div>
                                <div>
                                    <b>{currencyFormat(pendingInvoice.pendingAmount)}</b>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </>
    );
};